import React from 'react';
import SivaPhaseTag from './SivaPhaseTag';
import NumericIdLink from './NumericIdLink';
import { SivaContractsDetailDto, SivaPhase } from 'src/api/v2';
import { Card } from '@innovationnorway/component-library';
import { DateCell } from 'src/components/DataTableV3/components/formatters/Date';
import { useTranslation } from 'react-i18next';
import ValueField from 'src/components/ValueField/ValueField';

type Props = {
  sivaContract: SivaContractsDetailDto;
};

const SivaContractOverviewCard: React.FC<Props> = ({ sivaContract }) => {
  const { t: tSiva } = useTranslation('siva');
  const currentPhase = sivaContract.requestedContract.phases.sort(
    (a, b) => Number(b.fromDate) - Number(a.fromDate),
  )[0].sivaPhase;

  return (
    <Card boxShadow className="stack-small height--100 max-inline-size--50">
      <ValueField
        label={tSiva('company.details.contract.overview.id')}
        value={<NumericIdLink numericId={sivaContract.requestedContract.numericId} />}
      />
      <ValueField label={'Fase'} value={<SivaPhaseTag phase={currentPhase} />} />
      <ValueField
        label={
          currentPhase === SivaPhase.Idea
            ? tSiva('companyTabs.about.registeredDate')
            : tSiva('company.details.contract.overview.admissionDate')
        }
        value={
          <DateCell
            value={sivaContract.requestedContract.admissionDate ?? sivaContract.requestedContract.fromDate}
          />
        }
      />
      <ValueField label={'Rådgiver'} value={sivaContract.requestedContract.advisorName} />
    </Card>
  );
};

export default SivaContractOverviewCard;
